import React from 'react';

interface RadioOptionProps {
    id: string;
    label: string;
    checked: boolean;
    onChange: () => void;
    Icon?: any;
    classParent?: string;
    bgAfeterCheked?: string;
}

const RadioOption: React.FC<RadioOptionProps> = ({
    id,
    label,
    checked,
    onChange,
    Icon,
    classParent = 'p-3',
    bgAfeterCheked = 'bg-theme',
}) => {

    return (
        <label
            htmlFor={id}
            className={`d-flex align-items-center border rounded mb-2 cursor-pointer ${classParent} transition ${checked ? `border-light ${bgAfeterCheked} text-white` : ''}`}
            style={{
                cursor: 'pointer',
                ...(!checked
                    ? {
                          backgroundColor: 'var(--bg-secondary)',
                          color: 'var(--text-primary)',
                          borderColor: 'var(--border-subtle)',
                      }
                    : {}),
            }}
        >
            <input
                type="radio"
                id={id}
                name="referralSource"
                className="visually-hidden"
                checked={checked}
                onChange={onChange}
            />
            <div
                className={`rounded-circle border d-flex align-items-center justify-content-center me-3`}
                style={{
                    width: '20px',
                    height: '20px',
                    borderColor: checked ? '#0d6efd' : '#6c757d',
                }}
            >
                {checked && (
                    <div
                        className="rounded-circle"
                        style={{
                            width: '12px',
                            height: '12px',
                            backgroundColor: '#ffffff',
                        }}
                    />
                )}
            </div>
            {Icon && (
                <Icon
                    size={20}
                    className={`me-2 ${checked ? 'text-white' : ''}`}
                />
            )}
            <span className={checked ? 'text-white' : undefined}>{label}</span>
        </label>
    );
};

export default RadioOption;
